import { elements } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import wait from '@mailobj-browser/front/js/utils/wait.js'
import { get } from '#utilities/js/ea/ajax.js'
import href from '#utilities/js/ea/href.js'
import * as utilities from '#utilities/js/styles.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    button
  ) => {
    const container = closest(`[data-show-xfiles='attach']`, button)

    if (container) {
      const { value: mbox } = button
      const { dataset } = button
      const { scopeJson } = dataset
      let view = null
      if (scopeJson) {
        const json = JSON.parse(scopeJson)
        view = json.view
      }
      const url = href('mail/req_xfiles_getattach', {
        mbox: encodeURIComponent(mbox),
        update: 1,
        view: view,
      })
      let promise = get(url, { target: button })
      const loader = one(`.${elements.loader}`, container)
      const tableList = one(`.${elements.table_full}`, container)

      queueMicrotask(async () => {
        await wait(1000)

        if (promise) {
          if (loader && tableList) {
            loader.classList.remove(utilities.modifiers.display.none)
            tableList.classList.add(utilities.modifiers.display.none)
          }
        }
      })

      await promise
      promise = null
      if (loader) {
        loader.classList.add(utilities.modifiers.display.none)
      }
    }
  }
})

export default button => {
  onClick.listen(button)
}
